module.exports = __webpack_public_path__ + "static/media/Kuva_8_3.b7df6c72.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Kuva_8_3.png
// module id = 1405
// module chunks = 0